import { trackECommerceEvent } from '~/tools/analytics/googleAnalytics'

export function trackGA(view, prevProps, prevState) {
    const ga = window.ga;
    const dataLayer = window.dataLayer || { push: _ => {} }
    const plan = view.state.plans && view.state.plans[view.state.selectedPlan]
    const currencyCode = plan.planDetails[0].recurringPaymentCurrencyCode

    if (prevState.current !== view.state.current || prevState.plans !== view.state.plans) {
      if (view.state.current === 'selectPlan' && plan) {
        ga('set', 'currencyCode', currencyCode)
        view.state.plans.forEach((plan) => {
          trackECommerceEvent('ec:addImpression',{
            id: plan.id,
            name: plan.name,
            price: plan.planDetails[0].recurringPaymentAmount
          })
        })
        ga('send', 'event', 'e-commerce', 'impression'); 
        dataLayer.push({
          'event': 'view_plans'
        })
      }

      if (view.state.current === 'createAccount') {
        ga('ec:setAction', 'checkout', {'step': 1})
        ga('set', 'currencyCode', currencyCode)
        trackECommerceEvent('ec:addProduct',{
          id: plan.id,
          name: plan.name,
          price: plan.planDetails[0].recurringPaymentAmount,
          quantity: 1
        })
        ga('send', 'event', 'e-commerce', 'checkout', '1')
        dataLayer.push({
          'event': 'select_plan',
          'plan_currency_code': currencyCode,
          'plan_uuid': plan.id,
          'plan_name': plan.name,
          'plan_price': plan.planDetails[0].recurringPaymentAmount
        })
      }

      if (view.state.current === 'billing') {
        ga('ec:setAction', 'checkout', {'step': 2})
        ga('set', 'currencyCode', currencyCode)
        trackECommerceEvent('ec:addProduct',{
          id: plan.id,
          name: plan.name,
          price: plan.planDetails[0].recurringPaymentAmount,
          quantity: 1
        })
        ga('send', 'event', 'e-commerce', 'checkout', '2')
        dataLayer.push({
          'event': 'finish_registration',
          'plan_currency_code': currencyCode,
          'plan_uuid': plan.id,
          'plan_name': plan.name,
          'plan_price': plan.planDetails[0].recurringPaymentAmount
        })
      }

      if (view.state.current === 'thankyou') {
        ga('ec:setAction', 'checkout', {'step': 3})
        trackECommerceEvent('ec:addProduct',{
          id: plan.id,
          name: plan.name,
          price: plan.planDetails[0].recurringPaymentAmount,
          quantity: 1
        })
        ga('send', 'event', 'e-commerce', 'checkout', '3')
        ga('ec:setAction', 'purchase',{
          revenue: plan.planDetails[0].recurringPaymentAmount,
          id: `${view.state.user.userId} - ${Date.now()}`
        })
        trackECommerceEvent('ec:addProduct',{
          id: plan.id,
          name: plan.name,
          price: plan.planDetails[0].recurringPaymentAmount,
          quantity: 1
        })
        ga('set', 'currencyCode', currencyCode)
        ga('send', 'event', 'e-commerce', 'purchase');
        dataLayer.push({
          'event': 'finish_subscription',
          'plan_currency_code': currencyCode,
          'plan_uuid': plan.id,
          'plan_name': plan.name,
          'plan_price': plan.planDetails[0].recurringPaymentAmount,
          'transaction_id': `${view.state.user.userId} - ${Date.now()}`
        })
      }
    }
}